<template>
  <div>
    <ul class="list__items">
      <li class="list__item" v-bind:key="p.key" v-for="p in paginatedData">
        <span class="list__content">{{ p }}</span>
      </li>
    </ul>

    <button class="button button--paginate" :disabled="pageNumber === 0" @click="prevPage">Previous</button>
    <button class="button button--paginate" :disabled="pageNumber >= pageCount -1" @click="nextPage">Next</button>
  </div>
</template>

<script>
export default {
  name: 'AppPagination',
  data() {
    return {
      pageNumber: 0,
    };
  },
  props: {
    listData: {
      type: Array,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default: 10,
    },
  },
  methods: {
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
  },
  computed: {
    pageCount() {
      const l = this.listData.length;
      const s = this.size;
      return Math.ceil(l / s);
    },
    paginatedData() {
      const start = this.pageNumber * this.size;
      const end = start + this.size;
      return this.listData.slice(start, end);
    },
  },
};
</script>
